import PropTypes from 'prop-types';
import React from 'react';
import Responsive from 'react-responsive';
import { Button } from 'reactstrap';

import history from '../../utils/history';
import {
  getSessionStorageItem,
  removeSessionStorageItem,
} from '../../utils/sessionStorage';
import CircularLoading from '../Common/CircularLoading/CircularLoading';
import { TabletWidth } from '../Common/const.jsx';
import NotificationPopUp from '../Headers/NotificationPopUp';
import NotificationPopUpFree from '../Headers/NotificationPopUpFree';
import WarfareModal from '../PracticeExam/WarfareModal.jsx';
import calendarImg from './assets/calendar.png';
import CircularProgressBar from './CircularProgressBar.jsx';
// import QualDailyQuizButton from './QualDailyQuizButton';

class DailyQuiz extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: this.props.collapsed,
      showFreePopUpModal: false,
      showCancelPopUp: false,
      timer: 1200,
      dailyTimeOut: false,
      timerSetted: false,
      quizLoaded: false,
      openModal: false,
    };
    this.timer = null;
  }

  componentDidMount() {
    this.props.checkDailyQuizStatus();
    // this.props.checkQualDailyQuizStatus();
    if (getSessionStorageItem('quiz')) {
      removeSessionStorageItem('quiz');
    }
  }

  componentWillUnmount() {
    this.setState({
      timerSetted: false,
      quizLoaded: false,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pfeSktId !== this.props.pfeSktId) {
      this.props.checkDailyQuizStatus();
    }
    if (
      prevProps.dailyTimeOut != this.props.dailyTimeOut &&
      !this.props.dailyTimeOut
    ) {
      this.clearInterval(this.timer);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.quiz &&
      !this.state.quizLoaded &&
      history.location.pathname !== '/app/daily20quizReview'
    ) {
      this.setState({
        quizLoaded: true,
      });
      if (!this.state.timerSetted) {
        const remaining = nextProps.quiz.timeRemaining || 0;
        this.setState({
          timer: remaining > 0 ? remaining : 0,
          timerSetted: true,
        });
      }
    }
  }

  getMinutesOrHours(hours) {
    if (hours > 0 && hours < 1) {
      const minutes = Math.ceil(hours * 60);
      if (minutes === 1) {
        return `${minutes} Min`;
      }
      return `${minutes} Mins`;
    }
    if (hours === 1) {
      return `${hours} HR`;
    }
    return `${hours} HRS`;
  }

  clearInterval = (timer) => {
    clearInterval(timer);
  };

  startTimer = () => {
    this.timer = setInterval(() => {
      const { timer } = this.state;

      if (timer <= 1 || this.state.dailyTimeOut) {
        this.setState({ dailyTimeOut: true });
        this.clearInterval(this.timer);
      } else {
        this.setState({ timer: timer - 1 });
      }
    }, 1000);
  };

  handleOnStartQuiz = () => {
    if (
      this.props.nextQuizIn === -1 ||
      this.props.nextQuizIn > 0 ||
      this.state.dailyTimeOut
    ) {
      return; // isQuizDisabled
    }
    if (
      this.props.userSubscription &&
      this.props.userSubscription.warfarePlan
    ) {
      this.setState({ openModal: true });
    } else {
      if (this.props.user && this.props.user.id) {
        if (this.props.user.isFreeAccount) {
          this.openFreePopUp(true);
        } else if (!this.props.user.active) {
          this.openCancelPopUp(true);
        } else {
          if (this.props.dailyQuizRunning || this.props.nextQuizIn === 0) {
            history.push('/app/daily20quiz');
          }
        }
      }
    }
  };

  getButtonLabel() {
    if (this.props.dailyQuizRunning && !this.state.dailyTimeOut) {
      return (
        <div className="btn btn-outline-secondary rounded-lg launch-button px-1">
          {`${this.props.dailyQuizRunning} QUESTIONS REMAINING`}
        </div>
      );
    }
    if (this.props.nextQuizIn > 0) {
      return (
        <div className="btn btn-outline-download rounded-lg launch-button px-1">
          <i className="icon-clock" /> NEXT QUIZ IN{' '}
          {this.getMinutesOrHours(this.props.nextQuizIn)}
        </div>
      );
    }
    if (this.props.nextQuizIn === -1) {
      return (
        <div className="btn btn-outline-download btn-disabled-state rounded-lg launch-button px-1">
          QUIZ NOT AVAILABLE
        </div>
      );
    }
    if (this.state.dailyTimeOut) {
      return (
        <div className="btn btn-outline-download rounded-lg launch-button px-1">
          QUIZ ENDED BY TIME OUT
        </div>
      );
    }
    return (
      <div className="btn btn-outline-secondary rounded-lg launch-button px-1">
        {this.props.buttonText}
      </div>
    );
  }

  openFreePopUp = (value) => {
    this.setState({ showFreePopUpModal: value });
  };

  openCancelPopUp = (value) => {
    this.setState({ showCancelPopUp: value });
  };

  getCircularProgress = () => this.props.progress;
  // (this.props.progress + this.props.qualDailyQuizProgress) / 2;
  // that was used when QUAL daily quiz was available, now it only takes the percentage of the daily quiz

  render() {
    const circularProgress = this.getCircularProgress();
    let collapseButton = null;

    if (
      (this.props.checkDailyQuizStatusWaiting ||
        this.props.isQualDailyQuizLoading) &&
      !this.state.collapsed
    ) {
      return (
        <div className="daily-gif-container ml-3">
          <CircularLoading className="loading-gif-waiting daily-gif" />
        </div>
      );
    }

    if (!this.props.hover && this.props.initialCollapsedState) {
      collapseButton = (
        <Button
          color="link"
          onClick={this.props.toggleSidebar}
          className="collapseSidebar m-0"
        >
          <i className="icon-chevron_left" />
        </Button>
      );
    }

    if (!this.props.hover && this.props.collapsed) {
      let openSidebarButton = null;
      openSidebarButton = (
        <button
          onClick={this.props.toggleSidebar}
          className="sideBarOpener mx-auto"
        >
          <i className="icon-notes" />
        </button>
      );
      return openSidebarButton;
    }
    const isQuizDisabled =
      this.props.nextQuizIn === -1 ||
      this.props.nextQuizIn > 0 ||
      this.state.dailyTimeOut;

    return (
      <div>
        <div className="d-flex flex-column align-items-center">
          <CircularProgressBar
            strokeWidth="8"
            sqSize="111"
            imgSrc={calendarImg}
            percentage={circularProgress}
          />

          <Responsive maxDeviceWidth={TabletWidth}>{collapseButton}</Responsive>

          <div className="d-flex flex-column">
            <button
              className="mt-3 d-flex launch-button-container btn-transparent"
              onClick={this.handleOnStartQuiz}
              disabled={isQuizDisabled}
            >
              {this.getButtonLabel()}
            </button>

            {/* <QualDailyQuizButton
          user={this.props.user}
          openFreePopUp={this.openFreePopUp}
          openCancelPopUp={this.openCancelPopUp}
          setFlashSectionChoose={this.props.setFlashSectionChoose}
          userSelectedQual={this.props.user?.userSetting?.qualDailyQuiz}
          isQualDailyQuizRunning={this.props.isQualDailyQuizRunning}
          nextQualDailyQuizIn={this.props.nextQualDailyQuizIn}
          qualDailyQuizTimeout={this.props.qualDailyQuizTimeout}
          setQualDailyQuiz={this.props.setQualDailyQuiz}
          setOneQualDailyQuizHistory={this.props.setOneQualDailyQuizHistory}
        /> */}
          </div>
        </div>
        <NotificationPopUpFree
          isOpen={this.state.showFreePopUpModal}
          openFreePopUp={this.openFreePopUp}
        />
        <NotificationPopUp
          isOpen={this.state.showCancelPopUp}
          openCancelPopUp={this.openCancelPopUp}
          user={this.props.user}
        />
        {this.state.openModal && (
          <WarfareModal
            open={this.state.openModal}
            closeModal={() => this.setState({ openModal: false })}
          />
        )}
      </div>
    );
  }
}

DailyQuiz.propTypes = {
  quizAvailable: PropTypes.bool,
};

export default DailyQuiz;
